module.exports = __webpack_public_path__ + "static/media/phone-bottom-mode.5d3b0468.png";


//////////////////
// WEBPACK FOOTER
// ./src/contents/img/phone-bottom-mode.png
// module id = 3317
// module chunks = 0